import React from "react";
import Stars from "~/common/Stars";
import { FeaturedReview } from "~/ProductDetails/ProductDetailPageResult";

interface Props {
  review: FeaturedReview;
}

const FeaturedProductReview = ({ review }: Props) => {
  const featuredText = review.reviewText.trim().replace(/  +/g, " ");
  const reviewText =
    featuredText.length <= 280
      ? featuredText
      : `${featuredText.substring(0, 280)}...`;

  return (
    <div
      className="review featured-product-review"
      data-testid="expanded-featured-review"
    >
      <Stars rating={review.oneToFiveStarRating} />
      <p>{`"${reviewText}"`}</p>
      <a href="#reviews" className="btn btn-mini btn-light">
        Read More Reviews
      </a>
    </div>
  );
};

export default FeaturedProductReview;
